/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OnboardingProgress
 */
export interface OnboardingProgress {
    /**
     * 
     * @type {string}
     * @memberof OnboardingProgress
     */
    onboardingProgress: string;
}

/**
 * Check if a given object implements the OnboardingProgress interface.
 */
export function instanceOfOnboardingProgress(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "onboardingProgress" in value;

    return isInstance;
}

export function OnboardingProgressFromJSON(json: any): OnboardingProgress {
    return OnboardingProgressFromJSONTyped(json, false);
}

export function OnboardingProgressFromJSONTyped(json: any, ignoreDiscriminator: boolean): OnboardingProgress {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'onboardingProgress': json['onboarding_progress'],
    };
}

export function OnboardingProgressToJSON(value?: OnboardingProgress | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'onboarding_progress': value.onboardingProgress,
    };
}

